// // src/components/Navbar.js
// import React, { useState }  from "react";
// import { Link, useNavigate } from 'react-router-dom';
// import logo from '../../assests/images/horizontal_without_taglinel.png'

// const Navbar = () => {
//   const [menuOpen, setMenuOpen] = useState(false);
//   const navigate = useNavigate();

//   const OpenDrowDown = () => {
//     setMenuOpen(true)
//   }
  
//   const handleRequestDemoClick = () => {
//     navigate("/contact-us", {
//     state: { scrollToId: "contact-form" },
//   });

 
//     // navigate("/contact-us"); // First navigate
//     // setTimeout(() => {
//     //   const section = document.getElementById("contact-form");
//     //   if (section) {
//     //     section.scrollIntoView({ behavior: "smooth" }); // Then scroll
//     //   }
//     // }, 300); // Delay to allow page to render
//   };
//   return (
//     <div className="lg:px-20  2xl:px-44">
      
//       <nav className="ffixed top-4 left-0 w-[80%] z-[999] backdrop-blur-xl bg-neutral-900/90 shadow-lg rounded-full px-6 py-3 flex justify-between items-center text-white" style={{justifySelf: 'anchor-center'}}>
          
//       {/* Logo */}
//       <Link to="/" className="flex items-center">
//         <img
//           src={logo}
//           alt="Logo"
//           className="2xl:w-48 lg:w-36 h-8 object-contain rounded-md"
//         />
//       </Link>

//       {/* Desktop Menu */}
//       <div className="hidden lg:flex space-x-10 text-md font-medium">
//         <Link to="/">Home</Link>
//         <Link to="/about_us">About Us</Link>
//         <Link to="/staffing">Hire Developer</Link>
//         <Link to="/services">Services</Link>
//         <Link to="/portfolio">Portfolio</Link>
//         <Link to="/contact-us">Contact Us</Link>
//       </div>

//       {/* Hamburger Icon for Mobile */}
//       <div className="lg:hidden">
//         <button
//           onClick={OpenDrowDown}
//           className="text-3xl"
//           aria-label="Open Menu"
//         >
//           ☰
//         </button>
//       </div>

//       {/* CTA Button (Desktop Only) */}
//       <button
//         onClick={handleRequestDemoClick}
//         className="hidden lg:inline-block bg-[#007dc6] text-white px-5 py-2 rounded-full text-sm font-semibold shadow-inner"
//       >
//         Request Demo
//       </button>

//       {/* Mobile Dropdown Menu */}
//       {menuOpen && (
//         <div className="absolute top-full mt-3 left-0 w-full bg-neutral-900 text-white rounded-xl shadow-lg p-6 flex flex-col space-y-4 lg:hidden z-50">

//           {/* Close Button */}
//           <div className="flex justify-end">
//             <button
//               className="text-2xl text-white"
//               aria-label="Close Menu"
//             >
//               ✕
//             </button>
//           </div>

//           <Link to="/" onClick={() => setMenuOpen(false)}>Home</Link>
//           <Link to="/about_us" >About Us</Link>
//           <Link to="/staffing" >Hire Developer</Link>
//           <Link to="/services" >Services</Link>
//           <Link to="/portfolio" >Portfolio</Link>
//           <Link to="/contact-us" >Contact Us</Link>

//           <button
//             onClick={() => {
//               handleRequestDemoClick();
//               setMenuOpen(false);
//             }}
//             className="bg-[#007dc6] text-white px-4 py-2 rounded-full text-sm font-semibold shadow-inner"
//           >
//             Request Demo
//           </button>
//         </div>
//       )}
//     </nav>
// </div>

//   );
// };

// export default Navbar;

import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import logo from '../../assests/images/horizontal_without_taglinel.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleRequestDemoClick = () => {
    navigate("/contact-us", {
      state: { scrollToId: "contact-form" },
    });
    setMenuOpen(false); // Close menu on mobile
  };

  return (
    <div className="lg:px-20 2xl:px-44">
      <nav className="fixed top-4 left-1/2 transform -translate-x-1/2 z-[999] backdrop-blur-xl bg-neutral-900/90 shadow rounded-full px-6 py-3 flex justify-between items-center text-white w-[90%] md:w-[85%] lg:w-[80%] 2xl:w-[75%]">
        
        {/* Logo */}
        <Link to="/" className="flex items-center" onClick={() => setMenuOpen(false)}>
          <img
            src={logo}
            alt="Logo"
            className="2xl:w-48 lg:w-36 lg:h-8 h-16 w-52 object-contain rounded-md"
          />
        </Link>

        {/* Desktop Menu */}
        <div className="hidden lg:flex space-x-10 text-md font-medium">
          <Link to="/">Home</Link>
          <Link to="/about_us">About Us</Link>
          <Link to="/staffing">Hire Developer</Link>
          <Link to="/services">Services</Link>
          <Link to="/portfolio">Portfolio</Link>
          <Link to="/contact-us">Contact Us</Link>
        </div>

        {/* CTA Button (Desktop Only) */}
        <button
          onClick={handleRequestDemoClick}
          className="hidden lg:inline-block bg-[#007dc6] text-white px-5 py-2 rounded-full text-sm font-semibold shadow-inner"
        >
          Request Demo
        </button>

        {/* Hamburger Icon for Mobile */}
        <div className="lg:hidden">
          <button
            onClick={() => setMenuOpen(true)}
            className="text-4xl"
            aria-label="Open Menu"
          >
            ☰
          </button>
        </div>

        {/* Mobile Dropdown Menu */}
        {menuOpen && (
          <div className="absolute top-full mt-4 left-0 w-full bg-neutral-900 text-white rounded-xl shadow-lg p-6 flex flex-col space-y-4 lg:hidden z-50">

            {/* Close Button */}
            <div className="flex justify-end">
              <button
                className="text-3xl text-white"
                aria-label="Close Menu"
                onClick={() => setMenuOpen(false)}
              >
                ✕
              </button>
            </div>

            <Link className="text-[44px]" to="/" onClick={() => setMenuOpen(false)}>Home</Link>
            <Link className="text-[44px]" to="/about_us" onClick={() => setMenuOpen(false)}>About Us</Link>
            <Link className="text-[44px]" to="/staffing" onClick={() => setMenuOpen(false)}>Hire Developer</Link>
            <Link className="text-[44px]" to="/services" onClick={() => setMenuOpen(false)}>Services</Link>
            <Link className="text-[44px]" to="/portfolio" onClick={() => setMenuOpen(false)}>Portfolio</Link>
            <Link className="text-[44px]" to="/contact-us" onClick={() => setMenuOpen(false)}>Contact Us</Link>

            <button
              onClick={handleRequestDemoClick}
              className="bg-[#007dc6] text-white px-4 py-2 rounded-full text-[48px] font-semibold shadow-inner"
            >
              Request Demo
            </button>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Navbar;
